import * as React from 'react';
import {
  TypeImplementation,
  withSystem,
  Expressions,
} from '@packages/systems/wfdl';
import {
  TText,
  EText,
  TRecord,
  ERecord,
  EHole,
} from '@packages/systems/wfdl-ast';
import {updateExpressionAction} from '@packages/systems/ExpressionEditor-utils';
import {Select, Option} from '@packages/systems/design-system/WebflowSelect';
import {ItemSearchInputPopover} from '../components/ItemSearchInputPopover';
import {truncate} from '@packages/utilities/string-utils';

import {stripAll} from '@packages/utilities/contextual-expression';

const itemListType = withSystem(
  {isFullWidth: true},
  TRecord({name: TText, id: TText})
);

/**
 * The field that is below "View items" in the Delete/Update blocks
 */
export const ItemSearchAliasType = TypeImplementation.Alias({
  system: {bindUIVariant: 'custom'},
  type: itemListType,
  render: function ItemSearchAlias({expr, dispatch}) {
    const strippedExpr = stripAll(expr);
    const record = Expressions.getRecord(strippedExpr);

    // @ts-expect-error - TS2345 - Argument of type 'Expression | undefined' is not assignable to parameter of type 'ExpressionF<Expression>'.
    const nameText = record ? Expressions.getText(record.name) || '' : '';
    const onItemSelect = React.useCallback(
      // @ts-expect-error - TS7006 - Parameter 'item' implicitly has an 'any' type.
      (item) => {
        dispatch(
          updateExpressionAction(
            ERecord({name: EText(item.name), id: EText(item.id)})
          )
        );
      },
      [dispatch]
    );

    const onBindingChange = React.useCallback(
      // @ts-expect-error - TS7006 - Parameter 'optionId' implicitly has an 'any' type. | TS7006 - Parameter 'meta' implicitly has an 'any' type.
      (optionId, meta) => {
        if (
          meta.changeType === 'changeEnd' &&
          optionId &&
          optionId === 'unlink'
        ) {
          dispatch(updateExpressionAction(EHole()));
        }
      },
      [dispatch]
    );

    if (record) {
      return (
        <>
          <Select
            id="bound-item-select"
            data-automation-id="bound-item-select"
            value={nameText}
            onChange={onBindingChange}
            aria-label={`Selected item: ${nameText}`}
          >
            <Option
              key={`bound-item-select-${nameText}`}
              value={nameText}
              label={truncate(nameText, 36)}
              data-automation-id={`bound-item-select-${nameText}`}
            />
            <Option
              key="bound-item-unlink-option"
              value="unlink"
              label="Unlink item"
              data-automation-id="bound-item-unlink-option"
            />
          </Select>
        </>
      );
    } else {
      return <ItemSearchInputPopover onItemSelect={onItemSelect} />;
    }
  },
});
